import { captureExceptionWithMessage } from 'utils/logRocket'
export const pluralize = (word: string, count: number) => (count === 1 ? word : `${word}s`)
export const capitalizeStrings = (str: string = '') => {
  if (!str) {
    return ''
  }
  return str
    .split(' ')
    .map(val => val[0].toUpperCase() + val.substring(1).toLowerCase())
    .join(' ')
}
export function retrieveName(currentUser: any) {
  if (!currentUser) {
    captureExceptionWithMessage('No user was passed to retrieveName')
    return 'Your'
  }
  try {
    const [firstName] =
      currentUser?.name && currentUser.name?.length ? currentUser.name.split(/\s/) : []
    return `${firstName ?? currentUser?.email}'s`
  } catch (e) {
    captureExceptionWithMessage('Error retrieving name', e)
  }
  return 'Your'
}
